import elfium from "./module";
import "components/businessCase/businessCaseConstants";
import "components/businessCase/businessCaseDetailModalController";
import "components/businessCase/businessCaseLastStageFilter";
import "components/businessCase/businessCaseList";
import "components/businessCase/businessCaseListController";
import "components/businessCase/businessCaseListItem";
import "components/businessCase/businessCaseListItemController";
import "components/businessCase/businessCaseListItemDetail";
import "components/businessCase/businessCaseListItemDetailController";
import "components/businessCase/businessCaseNewModalController";
import "components/businessCase/businessCaseService";
import "components/businessCase/businessCaseStateFilter";
import "components/company/companyConstants";
import "components/company/companyDetailModalController";
import "components/company/companyHasOtherAddressFilter";
import "components/company/companyList";
import "components/company/companyListController";
import "components/company/companyService";
import "components/contact/contactConstants";
import "components/contact/contactDetailModalController";
import "components/contact/contactList";
import "components/contact/contactListController";
import "components/contact/contactService";
import "components/dashboard/dashboard";
import "components/dashboard/dashboardActivityList";
import "components/dashboard/dashboardActivityListController";
import "components/dashboard/dashboardController";
import "components/dashboard/dashboardFilter";
import "components/dashboard/dashboardFilterController";
import "components/dashboard/dashboardSumPanel";
import "components/dashboard/dashboardSumPanelController";
import "components/dashboard/dashboardSumService";
import "components/dashboard/dashboardTotalItem";
import "components/dashboard/dashboardTotalItemController";
import "components/dashboard/dashboardTotalService";
import "components/elfium/elfium";
import "components/elfium/elfiumConstants";
import "components/elfium/elfiumConvertFieldTypesFilter";
import "components/elfium/elfiumDateFilter";
import "components/elfium/elfiumDaterange";
import "components/elfium/elfiumDaterangeTwo";
import "components/elfium/elfiumFilterFilter";
import "components/elfium/elfiumGetNumberFilter";
import "components/elfium/elfiumListFilterFactory";
import "components/elfium/elfiumLoginService";
import "components/elfium/elfiumMissingRequiredFieldsFilter";
import "components/elfium/elfiumModalFactory";
import "components/elfium/elfiumOnEnter";
import "components/elfium/elfiumPageAccessService";
import "components/elfium/elfiumPreSaveFilter";
import "components/elfium/elfiumRelatedOptionsService";
import "components/elfium/elfiumRestService";
import "components/elfium/elfiumSort";
import "components/elfium/elfiumSortController";
import "components/elfium/elfiumSpinnerService";
import "components/elfium/elfiumSQLDateFilter";
import "components/elfium/elfiumToastrService";
import "components/elfium/elfiumUrlService";
import "components/navbar/navbar";
import "components/navbar/navbarController";
import "components/report/reportConstants";
import "components/report/reportContentService";
import "components/report/reportDtoService";
import "components/report/reportPhaseLabelFilter";
import "components/report/reportPhaseOrderFilter";
import "components/report/reportPhasesByTaskTypeFilter";
import "components/report/reportService";
import "components/report/reportTable";
import "components/report/reportTableController";
import "components/report/reportTableYear";
import "components/report/ReportYearService";
import "components/task/taskConstants";
import "components/task/taskDetailModalController";
import "components/task/taskGetNearestFilter";
import "components/task/taskList";
import "components/task/taskListController";
import "components/task/taskService";
import "components/task/taskSplitByTypeFilter";
import "components/user/userConstants";
import "components/user/userController";
import "components/user/userDetailModalController";
import "components/user/userList";
import "components/user/userLogin";
import "components/user/userRegister";
import "components/user/userService";

export default elfium.config(['$routeProvider', 'usSpinnerConfigProvider', 'uiSelectConfig', 'uibDatepickerConfig',
    function ($routeProvider, usSpinnerConfigProvider, uiSelectConfig, uibDatepickerConfig) {
        $routeProvider.when('/dashboard', {
            template:'<dashboard></dashboard>'
        }).when('/contacts', {
            template:'<contact-list></contact-list>'
        }).when('/companies', {
            template:'<company-list></company-list>'
        }).when('/businessCases', {
            template:'<business-case-list></business-case-list>'
        }).when('/tasks', {
            template:'<task-list></task-list>'
        }).when('/login', {
            template:'<user-login></user-login>'
        }).when('/register', {
            template:'<user-register></user-register>'
        }).when('/list', {
            template:'<user-list></user-list>'
        }).otherwise({
            redirectTo:'/dashboard'
        });

        uibDatepickerConfig.startingDay = '1';

        uiSelectConfig.theme = 'bootstrap';
        uiSelectConfig.resetSearchInput = true;
        uiSelectConfig.appendToBody = true;

        usSpinnerConfigProvider.setDefaults({
              lines: 15 // The number of lines to draw
            , length: 0 // The length of each line
            , width: 14 // The line thickness
            , radius: 51 // The radius of the inner circle
            , scale: 0.75 // Scales overall size of the spinner
            , corners: 0.9 // Corner roundness (0..1)
            , color: '#000' // #rgb or #rrggbb or array of colors
            , opacity: 0.2 // Opacity of the lines
            , rotate: 0 // The rotation offset
            , direction: 1 // 1: clockwise, -1: counterclockwise
            , speed: 0.7 // Rounds per second
            , trail: 28 // Afterglow percentage
            , fps: 20 // Frames per second when using setTimeout() as a fallback for CSS
            , zIndex: 2e9 // The z-index (defaults to 2000000000)
            , className: 'spinner' // The CSS class to assign to the spinner
            , top: '50%' // Top position relative to parent
            , left: '50%' // Left position relative to parent
            , shadow: false // Whether to render a shadow
            , hwaccel: false // Whether to use hardware acceleration
            , position: 'absolute' // Element positioning
        });
    }
]).run(['$rootScope', '$window', '$timeout', 'editableOptions', 'editableThemes', 'elfiumLoginService', 'elfiumPageAccessService', 'elfiumToastrService', function ($rootScope, $window, $timeout, editableOptions, editableThemes, elfiumLoginService, elfiumPageAccessService, elfiumToastrService) {
    editableOptions.theme = 'bs3';
    editableThemes.bs3.inputClass = 'input-sm';
    editableThemes.bs3.buttonsClass = 'btn-sm';
    $rootScope.$on('$routeChangeStart', function (event, next) {
        $timeout(function () {
            elfiumLoginService.checkUserLogin()['catch'](function () {
                $window.location = '#/login';
            });
        }, 300);
        var pageAccess = elfiumLoginService.getUserPageAccess();
        if (pageAccess && !elfiumPageAccessService.canAccessPage(next.$$route.originalPath, pageAccess)) {
            elfiumToastrService.warning('Tato stránka není přístupná.')
            event.preventDefault();
        }
    });
}])
.name;


// WEBPACK FOOTER //
// ./src/app/elfiumApp.ts